import css from './TextEditorLink.module.css'

const TextEditorLink = ({ attributes, children, element }: any) => {
    return (
        <a
            {...attributes}
            href={element.url}
            target="_blank"
            rel="noopener noreferrer"
            className={css.link}
            onClick={(e) => {
                e.preventDefault()
                window.open(element.url, '_blank', 'noopener,noreferrer')
            }}
        >
            {children}
        </a>
    )
}

export default TextEditorLink
